import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import SearchBoxViewModel from '@/Components/SearchView/SearchBox/SearchBoxViewModel';
import SearchBox from '@/Components/SearchView/SearchBox/SearchBox';

export default class SearchBoxFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private SearchBoxViewModel = ComponentManager.getViewModel<typeof SearchBoxViewModel>('SearchBoxViewModel');
    private SearchBox = ComponentManager.getControl<typeof SearchBox>('SearchBox');

    /**
     * @override
     */
    public viewModel: SearchBoxViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = this.detailViewItem.viewModel;
        this.control = new this.SearchBox(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('SearchBox', SearchBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');